import styled from 'styled-components';
import { Container, Segment } from 'semantic-ui-react';

export const SemanticContainer = styled(Container)`
  margin: 1em 0 0;
`;

export const SemanticSegment = styled(Segment)`
  text-align: center;
  position: relative;
  bottom: 0;
`;

